import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";
import ImageUpload from "../ImageFolder/ImageUpload";

import {
  createDiseaseAPI,
  createGroupAPI,
  createPackageTestAPI,
  createSubGroupAPI,
  createTestDetailsAPI,
  deletePackageTest,
  deleteTestCategory,
  deleteTestDetails,
  deleteTestSubCategory,
  listDiseaseAPI,
  listGroupAPI,
  listPackageAPI,
  listSubGroupAPI,
  listTestDetailsAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updatePackageTestAPI,
  updateSubGroupAPI,
  updateTestDetailsAPI,
} from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import {
  categoryDDAPI,
  categoryPackageDDAPI,
  categoryTestDDAPI,
  groupDDAPI,
  subCategoryDDAPI,
  testDDAPI,
} from "../../api/dropdown";
import MySelect from "../../MyComp/UI/form/MySelect";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import TextAreaInput from "../../MyComp/UI/form/TextAreaInput";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";

const TestDetails = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Table Columns
  const [column, setColumn] = useState([
    // {
    //   name: "Image",
    //   selector: (row) => (
    //     <div  >
    //       {/* <img
    //         style={{ width: "50px", height: "50px", borderRadius: "6px" }}
    //         src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
    //       /> */}
    //        <UserAvatarCell row={row} name={row?.name} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>

    //     </div>
    //   ),
    //   sortable: false,
    //   wrap: true,
    // },
    {
      name: "Test Name ",
      selector: (row) => row?.testname || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: " Details",
      selector: (row) => row?.detail,
      sortable: true,
      wrap: true,
    },

    //  {
    //   name: "Group  ",
    //   selector: (row) => row?.category|| "-",
    //   sortable: true,
    // wrap:true
    // },
    //  {
    //   name: "Sub Group  ",
    //   selector: (row) => row?.subCategory|| "-",
    //   sortable: true,
    // wrap:true
    // },

    // {
    //   name: "Status",
    //   selector: (row) => row?.status,
    //   cell: (row) => (
    //     <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
    //       <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
    //     </div>
    //   ),
    //   sortable: true,
    //   wrap: true,
    //   // width: "90px",
    // },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
    setValue("isLoading", true);

    deleteTestDetails({ id: watch("selectedRow").id })
      .then((res) => {
        setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Fetch group list
  useEffect(() => {
    getTestDetailsList();
  }, []);

  const getTestDetailsList = async () => {
    try {
      const res = await listTestDetailsAPI();
      if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === true) {
        setValue("data", res.data.data);
      } else {
        setValue("data", []);
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };

  const onFormSubmit = async (data) => {
    try {
      setValue("isLoading", true);

      // ✅ BODY DATA (JSON)
      const bodyData = {
        detail: data?.details,
        categoryId: data?.category?.value,
        subcategoryId: data?.subcategory?.value,
        test_id: data?.test?.value,
        testname: data?.test?.label,
        //   status: data?.status?.value,
      };

      // Edit case
      if (mode === "Edit") {
        bodyData.id = watch("selectedRow")?.id;
      }

      const res = mode === "Add" ? await createTestDetailsAPI(bodyData) : await updateTestDetailsAPI(bodyData);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        await getTestDetailsList();
        resetF();
        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };
  useEffect(() => {
    if (mode === "Add") {
      setValue("subcategory", null);
      setValue("test", null);
    }
  }, [watch("category")]);

  useEffect(() => {
    if (mode === "Add") {
      setValue("test", null);
    }
  }, [watch("subcategory")]);
  useEffect(() => {
    setValue("test", null);
  }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    setValue("subcategory", null);
  }, [watch("category")]);

  const handleEdit = async (row) => {
    window.scrollTo(0, 0);

    setMode("Edit");
    setIsOpen(true);
    setValue("selectedRow", row);

    setValue("details", row.detail);

    // 1️⃣ Category
    setValue("category", {
      label: row.category,
      value: row.categoryId,
    });

    // 2️⃣ Load subcategories
    await getSubCategory(row.categoryId);

    setValue("subcategory", {
      label: row.subCategory,
      value: row.subcategoryId,
    });

    // 3️⃣ Load tests
    await getTest(row.categoryId, row.subcategoryId);

    setValue("test", {
      label: row.testname, // ✅ fixed
      value: row.test_id,
    });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const resetF = () => {
    setValue("subcategory", null);
    setValue("details", null);
    setValue("test", null);
    setValue("category", null);
    setValue("status", null);
    setValue("addSub", false);
    setValue("group_img", null);
        clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const categoryId = watch("category")?.value;
    const subCategoryId = watch("subcategory")?.value;

    if (categoryId) {
      getSubCategory(categoryId);
    } else {
      setValue("subCategoryDD", []);
    }

    if (categoryId && subCategoryId) {
      getTest(categoryId, subCategoryId);
    } else {
      setValue("testDD", []);
    }
  }, [watch("category"), watch("subcategory")]);

  useEffect(() => {
    setValue("test", null);
  }, [watch("category"), watch("subcategory")]);
  useEffect(() => {
    setValue("subcategory", null);
  }, [watch("category")]);
  const getTest = (categoryId, subCategoryId) => {
    const body = {
      categoryId,
      subCategoryId,
    };

    testDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("testDD", res.data.data);
        } else if (res.data.status === "expired") {
        //   toast.error(res.data.message);
          logout();
        } else {
          setValue("testDD", []);
        //   toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const getSubCategory = (categoryId) => {
    const body = { categoryId };

    subCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
        //   toast.error(res.data.message);
          logout(); 
        } else {
          setValue("subCategoryDD", []);
        //   toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title=" Package | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Test Details
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  setIsOpen((pre) => !pre);
                  setMode("Add");
                  resetF();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  {mode==="Add" && (<Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Group"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>)}
                  {mode==="Add" &&(<Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Group"}
                      name={"subcategory"}
                      placeholder={"Select Sub Group"}
                      required
                      options={watch("subCategoryDD")}
                      // multi
                    />
                  </Col>)}
                  <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Test"}
                      name={"test"}
                      placeholder={"Select test"}
                      required
                      options={watch("testDD")}
                      // multi
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Sub Group Name"
                      name="name"
                      placeholder="Enter group name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}

                  {/* <Col md="3">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Sub Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      setError={setError}
                      getValues={getValues}
                    />
                  </Col> */}

                  {/* <Col md="3">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col> */}
                  <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Test Details"}
                      name={"details"}
                      placeholder={"Enter test details"}
                      required
                      // min={25}
                      // max={500}
                      cols={2}
                      row={2}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title=" Test Details List" isLoading={isLoading} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default TestDetails;
